import moment from "moment";

export const dateTimeLabel = (timestamp) => {
  if (!timestamp) {
    return "";
  }

  const inputDate = moment(timestamp);
  const today = moment();
  const tomorrow = moment().add(1, "days");

  if (inputDate.isSame(today, "day")) {
    return "Today - " + inputDate.format("HH:mm");
  } else if (inputDate.isSame(tomorrow, "day")) {
    return "Tomorrow - " + inputDate.format("HH:mm");
  } else {
    return inputDate.format("dddd, MMMM DD - HH:mm");
  }
};
